/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_Legal_Entity_NameInputs */

const cs_auth_signup_legal_entity_name = /** @type {(inputs: Auth_Signup_Legal_Entity_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obchodní jméno`)
};

const en_auth_signup_legal_entity_name = /** @type {(inputs: Auth_Signup_Legal_Entity_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business name`)
};

/**
* | output |
* | --- |
* | "Business name" |
*
* @param {Auth_Signup_Legal_Entity_NameInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_signup_legal_entity_name = /** @type {((inputs?: Auth_Signup_Legal_Entity_NameInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_Legal_Entity_NameInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_signup_legal_entity_name(inputs)
	return cs_auth_signup_legal_entity_name(inputs)
});